var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6431 19.7571C14.6431 18.1658 14.0109 16.6397 12.8857 15.5144C11.7605 14.3892 10.2344 13.7571 8.64307 13.7571C7.05177 13.7571 5.52564 14.3892 4.40043 15.5144C3.27521 16.6397 2.64307 18.1658 2.64307 19.7571",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64307 13.7571C10.8522 13.7571 12.6431 11.9662 12.6431 9.75708C12.6431 7.54794 10.8522 5.75708 8.64307 5.75708C6.43393 5.75708 4.64307 7.54794 4.64307 9.75708C4.64307 11.9662 6.43393 13.7571 8.64307 13.7571Z",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6431 19.7571C22.6431 18.1658 22.0109 16.6397 20.8857 15.5144C19.7605 14.3892 18.2344 13.7571 16.6431 13.7571C17.7039 13.7571 18.7213 13.3357 19.4715 12.5855C20.2216 11.8354 20.6431 10.8179 20.6431 9.75708C20.6431 8.69621 20.2216 7.6788 19.4715 6.92865C18.7213 6.17851 17.7039 5.75708 16.6431 5.75708",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.269e0e7a2d9845e5cb44c698501dba25.svg";
export { ForwardRef as ReactComponent };